// import React, { useState, useEffect } from "react";
// import {
//   Plus,
//   MapPin,
//   Phone,
//   Home,
//   Building,
//   User,
//   Check,
//   Briefcase,
//   Package,
//   Store,
// } from "lucide-react";
// import AddAddressModal from "../Address/AddAddressModal";
// import { useTranslation } from "react-i18next";

// const SelectAddressModal = ({ onAddressSelect }) => {
//   const [addresses, setAddresses] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedAddress, setSelectedAddress] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const { t } = useTranslation();

//   const getUserData = () => {
//     const userData = localStorage.getItem("pm-user-data");
//     return userData ? JSON.parse(userData) : null;
//   };

//   useEffect(() => {
//     fetchAddresses();
//   }, []);

//   const fetchAddresses = async () => {
//     try {
//       setLoading(true);
//       const user = getUserData();

//       if (!user || !user._id) {
//         throw new Error(t("address.user_not_found") || "User not found. Please login first.");
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/address/user/${user._id}`
//       );
      
//       if (!response.ok) {
//         throw new Error(t("address.fetch_failed") || "Failed to fetch addresses");
//       }
      
//       const data = await response.json();

//       if (data.success) {
//         const sortedAddresses = data.data.sort((a, b) => {
//           if (a.isDefault && !b.isDefault) return -1;
//           if (!a.isDefault && b.isDefault) return 1;
//           return new Date(b.updatedAt) - new Date(a.updatedAt);
//         });
//         setAddresses(sortedAddresses);

//         // Auto-select default address
//         const defaultAddress = sortedAddresses.find((addr) => addr.isDefault);
//         if (defaultAddress) {
//           setSelectedAddress(defaultAddress._id);
//           onAddressSelect && onAddressSelect(defaultAddress._id);
//         } else if (sortedAddresses.length > 0) {
//           // Select first address if no default
//           setSelectedAddress(sortedAddresses[0]._id);
//           onAddressSelect && onAddressSelect(sortedAddresses[0]._id);
//         }
//       } else {
//         setError(t("address.fetch_failed") || "Failed to fetch addresses");
//       }
//     } catch (err) {
//       setError(err.message);
//       console.error("Error fetching addresses:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getAddressTypeIcon = (type) => {
//     switch (type?.toLowerCase()) {
//       case "home":
//         return <Home className="w-4 h-4" />;
//       case "work":
//       case "office":
//         return <Briefcase className="w-4 h-4" />;
//       case "apartment":
//         return <Building className="w-4 h-4" />;
//       case "store":
//         return <Store className="w-4 h-4" />;
//       case "other":
//         return <Package className="w-4 h-4" />;
//       default:
//         return <User className="w-4 h-4" />;
//     }
//   };

//   const getAddressTypeColor = (type) => {
//     switch (type?.toLowerCase()) {
//       case "home":
//         return "text-blue-600 bg-blue-50";
//       case "work":
//       case "office":
//         return "text-purple-600 bg-purple-50";
//       case "apartment":
//         return "text-green-600 bg-green-50";
//       case "store":
//         return "text-orange-600 bg-orange-50";
//       case "other":
//         return "text-gray-600 bg-gray-50";
//       default:
//         return "text-gray-600 bg-gray-50";
//     }
//   };

//   const getAddressTypeText = (type) => {
//     switch (type?.toLowerCase()) {
//       case "home":
//         return t("address.type_home") || "Home";
//       case "work":
//       case "office":
//         return t("address.type_work") || "Work";
//       case "apartment":
//         return t("address.type_apartment") || "Apartment";
//       case "store":
//         return t("address.type_store") || "Store";
//       case "other":
//         return t("address.type_other") || "Other";
//       default:
//         return type || t("address.type_other") || "Other";
//     }
//   };

//   const handleAddressSelect = (addressId) => {
//     setSelectedAddress(addressId);
//     onAddressSelect && onAddressSelect(addressId);
//   };

//   const handleAddNewAddress = () => {
//     setIsModalOpen(true);
//   };

//   const handleAddressAdded = (newAddress) => {
//     setAddresses((prev) => {
//       const updated = [...prev, newAddress];
//       const sorted = updated.sort((a, b) => {
//         if (a.isDefault && !b.isDefault) return -1;
//         if (!a.isDefault && b.isDefault) return 1;
//         return new Date(b.updatedAt) - new Date(a.updatedAt);
//       });
//       return sorted;
//     });

//     if (newAddress.isDefault) {
//       setSelectedAddress(newAddress._id);
//       onAddressSelect && onAddressSelect(newAddress._id);
//     }

//     setIsModalOpen(false);
//   };

//   const handleAddressUpdated = (updatedAddress) => {
//     setAddresses((prev) => {
//       const updated = prev.map(addr => 
//         addr._id === updatedAddress._id ? updatedAddress : addr
//       );
//       const sorted = updated.sort((a, b) => {
//         if (a.isDefault && !b.isDefault) return -1;
//         if (!a.isDefault && b.isDefault) return 1;
//         return new Date(b.updatedAt) - new Date(a.updatedAt);
//       });
//       return sorted;
//     });

//     if (updatedAddress.isDefault) {
//       setSelectedAddress(updatedAddress._id);
//       onAddressSelect && onAddressSelect(updatedAddress._id);
//     }
//   };

//   const handleAddressDeleted = (deletedAddressId) => {
//     setAddresses((prev) => {
//       const filtered = prev.filter(addr => addr._id !== deletedAddressId);
//       if (selectedAddress === deletedAddressId && filtered.length > 0) {
//         const newSelected = filtered.find(addr => addr.isDefault) || filtered[0];
//         setSelectedAddress(newSelected._id);
//         onAddressSelect && onAddressSelect(newSelected._id);
//       } else if (filtered.length === 0) {
//         setSelectedAddress(null);
//         onAddressSelect && onAddressSelect(null);
//       }
//       return filtered;
//     });
//   };

//   const AddressSkeleton = () => {
//     return (
//       <div className="space-y-4">
//         {[1, 2].map((_, index) => (
//           <div
//             key={index}
//             className="animate-pulse border rounded-lg p-4 bg-white"
//           >
//             <div className="flex items-start gap-3">
//               <div className="w-5 h-5 rounded-full bg-gray-200 mt-1"></div>
//               <div className="flex-1 space-y-3">
//                 <div className="flex justify-between">
//                   <div className="h-4 bg-gray-200 rounded w-1/3"></div>
//                   <div className="h-4 bg-gray-200 rounded w-16"></div>
//                 </div>
//                 <div className="space-y-2">
//                   <div className="h-3 bg-gray-200 rounded w-full"></div>
//                   <div className="h-3 bg-gray-200 rounded w-4/5"></div>
//                   <div className="h-3 bg-gray-200 rounded w-3/4"></div>
//                 </div>
//                 <div className="h-4 bg-gray-200 rounded w-1/2"></div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     );
//   };

//   const formatPhoneNumber = (phone) => {
//     if (!phone) return "";
//     // Format as XXX-XXX-XXXX
//     return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-sm p-6">
//       <div className="flex items-center justify-between mb-6">
//         <div>
//           <h2 className="text-xl font-semibold font-philosopher text-gray-900">
//             {t("address.delivery_address") || "Delivery Address"}
//           </h2>
//           <p className="text-sm text-gray-500 mt-1">
//             {t("address.select_delivery_address") || "Select where you want your order delivered"}
//           </p>
//         </div>
//         <button
//           onClick={handleAddNewAddress}
//           className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-orange-600 bg-orange-50 hover:bg-orange-100 rounded-lg transition-colors duration-200"
//         >
//           <Plus className="w-4 h-4" />
//           {t("address.add_new") || "Add New"}
//         </button>
//       </div>

//       {loading ? (
//         <AddressSkeleton />
//       ) : error ? (
//         <div className="p-8 text-center">
//           <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
//             <MapPin className="w-12 h-12 text-red-400 mx-auto mb-3" />
//             <p className="text-red-700 font-medium mb-2">
//               {t("address.error_loading") || "Error loading addresses"}
//             </p>
//             <p className="text-red-600 text-sm mb-4">{error}</p>
//             <button
//               onClick={fetchAddresses}
//               className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium"
//             >
//               {t("address.retry") || "Retry"}
//             </button>
//           </div>
//         </div>
//       ) : (
//         <div>
//           {addresses.length === 0 ? (
//             <div className="text-center py-8">
//               <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
//                 <MapPin className="w-8 h-8 text-gray-400" />
//               </div>
//               <h3 className="text-lg font-medium text-gray-900 mb-2">
//                 {t("address.no_saved_addresses") || "No saved addresses"}
//               </h3>
//               <p className="text-gray-600 mb-6 max-w-md mx-auto">
//                 {t("address.no_addresses_message") || "Add your delivery address to get started with your order"}
//               </p>
//               <button
//                 onClick={handleAddNewAddress}
//                 className="px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors font-medium"
//               >
//                 {t("address.add_first_address") || "Add Your First Address"}
//               </button>
//             </div>
//           ) : (
//             <div className="space-y-4">
//               {addresses.map((address) => (
//                 <div
//                   key={address._id}
//                   className={`border-2 rounded-xl p-5 cursor-pointer transition-all duration-200 hover:shadow-lg ${
//                     selectedAddress === address._id
//                       ? "border-orange-500 bg-orange-50"
//                       : "border-gray-200 hover:border-gray-300 bg-white"
//                   }`}
//                   onClick={() => handleAddressSelect(address._id)}
//                 >
//                   <div className="flex items-start gap-4">
//                     {/* Selection Indicator */}
//                     <div className="mt-1">
//                       <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
//                         selectedAddress === address._id
//                           ? "border-orange-500 bg-orange-500"
//                           : "border-gray-300"
//                       }`}>
//                         {selectedAddress === address._id && (
//                           <Check className="w-3 h-3 text-white" />
//                         )}
//                       </div>
//                     </div>

//                     {/* Address Content */}
//                     <div className="flex-1">
//                       <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
//                         <div className="flex items-center gap-3">
//                           <h4 className="font-semibold text-gray-900 text-lg">
//                             {address.fullName}
//                           </h4>
//                           <div className={`flex items-center gap-1 px-2 py-1 rounded-full ${getAddressTypeColor(address.addressType)}`}>
//                             {getAddressTypeIcon(address.addressType)}
//                             <span className="text-xs font-medium">
//                               {getAddressTypeText(address.addressType)}
//                             </span>
//                           </div>
//                         </div>
                        
//                         <div className="flex items-center gap-2">
//                           {address.isDefault && (
//                             <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full font-medium">
//                               {t("address.default") || "DEFAULT"}
//                             </span>
//                           )}
//                         </div>
//                       </div>

//                       {/* Address Details */}
//                       <div className="text-gray-700 space-y-2">
//                         <div className="flex items-start gap-2">
//                           <MapPin className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0" />
//                           <div className="space-y-1">
//                             <p className="font-medium">{address.addressLine1}</p>
//                             {address.addressLine2 && (
//                               <p className="text-gray-600">{address.addressLine2}</p>
//                             )}
//                             <p className="text-gray-600">
//                               {address.city}, {address.state} - {address.postalCode}
//                             </p>
//                             {address.landmark && (
//                               <p className="text-sm text-gray-500">
//                                 {t("address.near") || "Near"}: {address.landmark}
//                               </p>
//                             )}
//                             <p className="text-gray-600">{address.country}</p>
//                           </div>
//                         </div>

//                         <div className="flex items-center gap-2 text-gray-700">
//                           <Phone className="w-4 h-4 text-gray-500" />
//                           <span className="font-medium">
//                             {formatPhoneNumber(address.phone)}
//                           </span>
//                         </div>
//                       </div>

//                       {/* Address Actions (Optional - can be added for edit/delete) */}
//                       <div className="flex items-center gap-3 mt-4 pt-4 border-t border-gray-100">
//                         <button
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             // Implement edit functionality
//                             console.log("Edit address:", address._id);
//                           }}
//                           className="text-sm text-blue-600 hover:text-blue-800 font-medium"
//                         >
//                           {t("address.edit") || "Edit"}
//                         </button>
//                         {!address.isDefault && (
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               // Implement delete functionality
//                               console.log("Delete address:", address._id);
//                             }}
//                             className="text-sm text-red-600 hover:text-red-800 font-medium"
//                           >
//                             {t("address.delete") || "Delete"}
//                           </button>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       {selectedAddress && addresses.length > 0 && (
//         <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg animate-fade-in">
//           <div className="flex items-center gap-3">
//             <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
//               <Check className="w-4 h-4 text-green-600" />
//             </div>
//             <div>
//               <p className="font-medium text-green-800">
//                 {t("address.delivery_selected") || "Delivery address selected"}
//               </p>
//               <p className="text-sm text-green-700 mt-0.5">
//                 {t("address.delivery_confirmation") || "Your order will be delivered to the selected address"}
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       <AddAddressModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         onAddressAdded={handleAddressAdded}
//         onAddressUpdated={handleAddressUpdated}
//         onAddressDeleted={handleAddressDeleted}
//       />

//       {/* Instructions */}
//       {addresses.length > 0 && (
//         <div className="mt-6 pt-6 border-t border-gray-200">
//           <p className="text-sm text-gray-500">
//             {t("address.selection_instructions") || "Click on an address to select it for delivery"}
//           </p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SelectAddressModal;







import React, { useState, useEffect } from "react";
import {
  Plus,
  MapPin,
  Phone,
  Home,
  Building,
  User,
  Check,
  Briefcase,
  Package,
  Store,
} from "lucide-react";
import AddAddressModal from "../Address/AddAddressModal";
import EditAddressModal from "../Address/EditAddressModal";    
import DeleteAlertModal from "../../common/DeleteAlertModal";     
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

const SelectAddressModal = ({ onAddressSelect }) => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  // Edit modal state
  const [editingAddress, setEditingAddress] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // Delete modal state
  const [deletingAddressId, setDeletingAddressId] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const getUserData = () => {
    const userData = localStorage.getItem("pm-user-data");
    return userData ? JSON.parse(userData) : null;
  };

  const fetchAddresses = async () => {
    try {
      setLoading(true);
      const user = getUserData();
      if (!user || !user._id) {
        throw new Error(t("address.user_not_found") || "User not found. Please login first.");
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/address/user/${user._id}`
      );
      if (!response.ok) {
        throw new Error(t("address.fetch_failed") || "Failed to fetch addresses");
      }
      const data = await response.json();

      if (data.success) {
        const sortedAddresses = data.data.sort((a, b) => {
          if (a.isDefault && !b.isDefault) return -1;
          if (!a.isDefault && b.isDefault) return 1;
          return new Date(b.updatedAt) - new Date(a.updatedAt);
        });
        setAddresses(sortedAddresses);

        // Auto-select default address (or first if none default)
        const defaultAddress = sortedAddresses.find((addr) => addr.isDefault);
        if (defaultAddress) {
          setSelectedAddress(defaultAddress._id);
          onAddressSelect && onAddressSelect(defaultAddress._id);
        } else if (sortedAddresses.length > 0) {
          setSelectedAddress(sortedAddresses[0]._id);
          onAddressSelect && onAddressSelect(sortedAddresses[0]._id);
        } else {
          setSelectedAddress(null);
          onAddressSelect && onAddressSelect(null);
        }
      } else {
        setError(t("address.fetch_failed") || "Failed to fetch addresses");
      }
    } catch (err) {
      setError(err.message);
      console.error("Error fetching addresses:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  // ----- Edit flow -----
  const openEditModal = (address) => {
    setEditingAddress(address);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingAddress(null);
  };

  const handleAddressUpdated = (updatedAddress) => {
    // Update local state optimistically
    setAddresses((prev) => {
      const updated = prev.map(addr =>
        addr._id === updatedAddress._id ? updatedAddress : addr
      );
      const sorted = updated.sort((a, b) => {
        if (a.isDefault && !b.isDefault) return -1;
        if (!a.isDefault && b.isDefault) return 1;
        return new Date(b.updatedAt) - new Date(a.updatedAt);
      });
      return sorted;
    });

    // If the updated address becomes default, update selection
    if (updatedAddress.isDefault) {
      setSelectedAddress(updatedAddress._id);
      onAddressSelect && onAddressSelect(updatedAddress._id);
    } else if (selectedAddress === updatedAddress._id && !updatedAddress.isDefault) {
      // If it was selected but no longer default, keep it selected (still valid)
      // No change needed
    }
    toast.success(t("address.update_success") || "Address updated successfully");
  };

  // ----- Delete flow -----
  const openDeleteModal = (addressId) => {
    setDeletingAddressId(addressId);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!deletingAddressId) return;
    setDeleteLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/address/delete-address/${deletingAddressId}`,
        { method: "DELETE" }
      );
      if (!response.ok) throw new Error("Delete failed");
      const data = await response.json();
      if (data.success) {
        // Remove from local state
        setAddresses((prev) => {
          const filtered = prev.filter(addr => addr._id !== deletingAddressId);
          if (selectedAddress === deletingAddressId) {
            // Select another address if available
            const newSelected = filtered.find(addr => addr.isDefault) || filtered[0] || null;
            setSelectedAddress(newSelected?._id || null);
            onAddressSelect && onAddressSelect(newSelected?._id || null);
          }
          return filtered;
        });
        toast.success(t("address.delete_success") || "Address deleted successfully");
      } else {
        throw new Error(data.message || "Delete failed");
      }
    } catch (err) {
      console.error("Delete error:", err);
      toast.error(t("address.delete_failed") || "Failed to delete address");
    } finally {
      setDeleteLoading(false);
      setIsDeleteModalOpen(false);
      setDeletingAddressId(null);
    }
  };

  // ----- Add new address callbacks -----
  const handleAddressAdded = (newAddress) => {
    setAddresses((prev) => {
      const updated = [...prev, newAddress];
      const sorted = updated.sort((a, b) => {
        if (a.isDefault && !b.isDefault) return -1;
        if (!a.isDefault && b.isDefault) return 1;
        return new Date(b.updatedAt) - new Date(a.updatedAt);
      });
      return sorted;
    });
    if (newAddress.isDefault) {
      setSelectedAddress(newAddress._id);
      onAddressSelect && onAddressSelect(newAddress._id);
    }
    setIsModalOpen(false);
  };

  const handleAddressUpdatedFromAddModal = (updatedAddress) => {
    // Same as handleAddressUpdated, but called from AddAddressModal if needed
    handleAddressUpdated(updatedAddress);
  };

  const handleAddressDeletedFromAddModal = (deletedAddressId) => {
    // Called from AddAddressModal when deletion happens inside it
    setAddresses((prev) => {
      const filtered = prev.filter(addr => addr._id !== deletedAddressId);
      if (selectedAddress === deletedAddressId) {
        const newSelected = filtered.find(addr => addr.isDefault) || filtered[0] || null;
        setSelectedAddress(newSelected?._id || null);
        onAddressSelect && onAddressSelect(newSelected?._id || null);
      }
      return filtered;
    });
    toast.success(t("address.delete_success") || "Address deleted");
  };

  // ----- Helpers for UI -----
  const getAddressTypeIcon = (type) => {
    switch (type?.toLowerCase()) {
      case "home": return <Home className="w-4 h-4" />;
      case "work": case "office": return <Briefcase className="w-4 h-4" />;
      case "apartment": return <Building className="w-4 h-4" />;
      case "store": return <Store className="w-4 h-4" />;
      default: return <User className="w-4 h-4" />;
    }
  };

  const getAddressTypeColor = (type) => {
    switch (type?.toLowerCase()) {
      case "home": return "text-blue-600 bg-blue-50";
      case "work": case "office": return "text-purple-600 bg-purple-50";
      case "apartment": return "text-green-600 bg-green-50";
      case "store": return "text-orange-600 bg-orange-50";
      default: return "text-gray-600 bg-gray-50";
    }
  };

  const getAddressTypeText = (type) => {
    switch (type?.toLowerCase()) {
      case "home": return t("address.type_home") || "Home";
      case "work": case "office": return t("address.type_work") || "Work";
      case "apartment": return t("address.type_apartment") || "Apartment";
      case "store": return t("address.type_store") || "Store";
      default: return type || t("address.type_other") || "Other";
    }
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  };

  const AddressSkeleton = () => (
    <div className="space-y-4">
      {[1, 2].map((_, index) => (
        <div key={index} className="animate-pulse border rounded-lg p-4 bg-white">
          <div className="flex items-start gap-3">
            <div className="w-5 h-5 rounded-full bg-gray-200 mt-1"></div>
            <div className="flex-1 space-y-3">
              <div className="flex justify-between">
                <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                <div className="h-4 bg-gray-200 rounded w-16"></div>
              </div>
              <div className="space-y-2">
                <div className="h-3 bg-gray-200 rounded w-full"></div>
                <div className="h-3 bg-gray-200 rounded w-4/5"></div>
                <div className="h-3 bg-gray-200 rounded w-3/4"></div>
              </div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold font-philosopher text-gray-900">
            {t("address.delivery_address") || "Delivery Address"}
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            {t("address.select_delivery_address") || "Select where you want your order delivered"}
          </p>
        </div>
        <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-orange-600 bg-orange-50 hover:bg-orange-100 rounded-lg transition-colors duration-200"
        >
          <Plus className="w-4 h-4" />
          {t("address.add_new") || "Add New"}
        </button>
      </div>

      {loading ? (
        <AddressSkeleton />
      ) : error ? (
        <div className="p-8 text-center">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
            <MapPin className="w-12 h-12 text-red-400 mx-auto mb-3" />
            <p className="text-red-700 font-medium mb-2">{t("address.error_loading") || "Error loading addresses"}</p>
            <p className="text-red-600 text-sm mb-4">{error}</p>
            <button
              onClick={fetchAddresses}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium"
            >
              {t("address.retry") || "Retry"}
            </button>
          </div>
        </div>
      ) : (
        <div>
          {addresses.length === 0 ? (
            <div className="text-center py-8">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="w-8 h-8 text-gray-400" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                {t("address.no_saved_addresses") || "No saved addresses"}
              </h3>
              <p className="text-gray-600 mb-6 max-w-md mx-auto">
                {t("address.no_addresses_message") || "Add your delivery address to get started with your order"}
              </p>
              <button
                onClick={() => setIsModalOpen(true)}
                className="px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors font-medium"
              >
                {t("address.add_first_address") || "Add Your First Address"}
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              {addresses.map((address) => (
                <div
                  key={address._id}
                  className={`border-2 rounded-xl p-5 cursor-pointer transition-all duration-200 hover:shadow-lg ${
                    selectedAddress === address._id
                      ? "border-orange-500 bg-orange-50"
                      : "border-gray-200 hover:border-gray-300 bg-white"
                  }`}
                  onClick={() => {
                    setSelectedAddress(address._id);
                    onAddressSelect && onAddressSelect(address._id);
                  }}
                >
                  <div className="flex items-start gap-4">
                    <div className="mt-1">
                      <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
                        selectedAddress === address._id
                          ? "border-orange-500 bg-orange-500"
                          : "border-gray-300"
                      }`}>
                        {selectedAddress === address._id && (
                          <Check className="w-3 h-3 text-white" />
                        )}
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
                        <div className="flex items-center gap-3">
                          <h4 className="font-semibold text-gray-900 text-lg">
                            {address.fullName}
                          </h4>
                          <div className={`flex items-center gap-1 px-2 py-1 rounded-full ${getAddressTypeColor(address.addressType)}`}>
                            {getAddressTypeIcon(address.addressType)}
                            <span className="text-xs font-medium">
                              {getAddressTypeText(address.addressType)}
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          {address.isDefault && (
                            <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full font-medium">
                              {t("address.default") || "DEFAULT"}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="text-gray-700 space-y-2">
                        <div className="flex items-start gap-2">
                          <MapPin className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0" />
                          <div className="space-y-1">
                            <p className="font-medium">{address.addressLine1}</p>
                            {address.addressLine2 && <p className="text-gray-600">{address.addressLine2}</p>}
                            <p className="text-gray-600">
                              {address.city}, {address.state} - {address.postalCode}
                            </p>
                            {address.landmark && (
                              <p className="text-sm text-gray-500">
                                {t("address.near") || "Near"}: {address.landmark}
                              </p>
                            )}
                            <p className="text-gray-600">{address.country}</p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2 text-gray-700">
                          <Phone className="w-4 h-4 text-gray-500" />
                          <span className="font-medium">{formatPhoneNumber(address.phone)}</span>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="flex items-center gap-3 mt-4 pt-4 border-t border-gray-100">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            openEditModal(address);
                          }}
                          className="text-sm text-blue-600 hover:text-blue-800 font-medium"
                        >
                          {t("address.edit") || "Edit"}
                        </button>
                        {!address.isDefault && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              openDeleteModal(address._id);
                            }}
                            className="text-sm text-red-600 hover:text-red-800 font-medium"
                          >
                            {t("address.delete") || "Delete"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {selectedAddress && addresses.length > 0 && (
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg animate-fade-in">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
              <Check className="w-4 h-4 text-green-600" />
            </div>
            <div>
              <p className="font-medium text-green-800">
                {t("address.delivery_selected") || "Delivery address selected"}
              </p>
              <p className="text-sm text-green-700 mt-0.5">
                {t("address.delivery_confirmation") || "Your order will be delivered to the selected address"}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      <AddAddressModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAddressAdded={handleAddressAdded}
        onAddressUpdated={handleAddressUpdatedFromAddModal}
        onAddressDeleted={handleAddressDeletedFromAddModal}
      />

      <EditAddressModal
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        address={editingAddress}
        onAddressUpdated={handleAddressUpdated}
      />

      <DeleteAlertModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        dltType="address"
        dltName={addresses.find(a => a._id === deletingAddressId)?.addressLine1 || "address"}
        onConfirm={confirmDelete}
        dltLoading={deleteLoading}
      />

      {addresses.length > 0 && (
        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            {t("address.selection_instructions") || "Click on an address to select it for delivery"}
          </p>
        </div>
      )}
    </div>
  );
};

export default SelectAddressModal;